import(/* webpackMode: "eager" */ "/codebuild/output/src1185444561/src/web/app/global-error.tsx");
